import { useLocation, useParams } from "react-router";

// Each value is the trailing URL path segment of a child route registered
// under the `:collectionId` parent in CollectionsRoutes. The string values are
// load-bearing: they are matched against `location.pathname` to identify
// the active tab, and used as `<Link to={...}>` targets to navigate between
// tabs. Renaming a value requires updating the matching `<Route path>` in
// CollectionsRoutes.
export enum CollectionTab {
  Items = "items",
  Details = "details",
  Activity = "activity",
  Permissions = "permissions",
}

function deriveActiveTabFromUrl(path: string | undefined): CollectionTab {
  switch (path) {
    case CollectionTab.Details:
      return CollectionTab.Details;
    case CollectionTab.Activity:
      return CollectionTab.Activity;
    case CollectionTab.Permissions:
      return CollectionTab.Permissions;
    default:
      return CollectionTab.Items;
  }
}

export function useActiveCollectionTab(): CollectionTab {
  const location = useLocation();
  const { collectionId } = useParams<{ collectionId: string }>();
  const segments = location.pathname.split("/").filter(Boolean);
  const path = segments[segments.indexOf(collectionId ?? "") + 1];
  return deriveActiveTabFromUrl(path);
}
